import { useDownloadCsv } from '@fukuri-admins/hooks/common';

type Options = {
  onSuccess?: (blob: Blob) => void;
  onError?: (error: Error) => void;
};

/**
 * 初回ログイン未完了者一覧 CSV ダウンロードフック（任意発火）
 *
 * `GET /api/v1/:threeLetterCode/client_admins/users.csv?f=pending` で CSV を取得し、
 * `trigger()` 呼び出し時に 1 回だけダウンロードする。
 */
export const useGetClientUsersCsv = (threeLetterCode: string, options?: Options) =>
  useDownloadCsv(`/api/v1/${threeLetterCode}/client_admins/users.csv?f=pending`, options);
